<template>
  <v-expand-x-transition class='w-expandable-x'>
    <div
      v-show='value'
      class='w-expandable-x__content-wrapper'
    >
      <slot />
    </div>
  </v-expand-x-transition>
</template>

<script>
import { useTimerManager } from '@/composables/timer-manager';

export default {
  name: 'WorkExpandableX',
  props: {
    value: { type: Boolean, required: true },
    withoutTransitionEvents: { type: Boolean, default: false },
  },
  setup() {
    const { registerTimeout } = useTimerManager();
    return {
      registerTimeout,
    };
  },
  watch: {
    value() {
      if (this.withoutTransitionEvents === true) { return }

      this.$emit('transisiton:started');
      this.registerTimeout(() => this.$emit('transisiton:finished'), 300);
    }
  }
};
</script>
